
import { TicketFilters } from "@/utils/ticket-filters";
import Vue from "vue";
import {ISelectItem} from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
		};
	},
	props: {
		limit: {
			type: Number,
			required: true
		},
		records: {
			type: Number,
			required: true
		},
		page: {
			type: Number,
			required: true
		},
		showTicketFilters: {
			type: Boolean,
			required: false
		},
		value: {
			type: Object as () => TicketFilters,
			required: false
		}
	},
	computed: {
		limitItems(): ISelectItem<number>[] {
			let limits = [1, 2, 5, 10, 20, 25, 50, 100, 200, 250, 500];
			return limits.map(l => {
				if (l == 1) {
					return {
						text: "Toon " + l + " lijn per pagina",
						value: l
					};
				}
				return {
					text: "Toon " + l + " lijnen per pagina",
					value: l
				};
			});
		},
		pages(): number {
			return Math.ceil(this.records / this.limit);
		},
		showTotalRecordsText(): string {
			return "Aantal lijnen: " + this.records;
		},
		showToggleUnread(): string {
			if(!this.value){
				return "";
			}
			return this.value.read !== false ? "Toon enkel ongelezen" : "Toon gelezen en ongelezen";
		}
	},
	methods: {
		onLimitChange(val: number) {
			this.$emit("limit", val);
		},
		onPageChange(val: number) {
			this.$emit("page", val);
		},
		toggleUnread() {
			this.$emit("toggle");
		}
	}
});
